const validationErrorStyle = (target,errorMessage) => {    
    for (let i = 0; i < target.length; i++) {
		if (target[i].tagName !== "BUTTON" && !target[i].disabled && target[i].name !== "hidden_input") {
			if (errorMessage[target[i].name] !== undefined) {
				if (!target[i].className.includes("demo")) {
					if (target[i].className !== "") {
						target[i].className += " demoClass";
						target[i].style.cssText = "outline: red solid 2px";
						target[i].style.cssText = "outline: red solid 2px";
					} else {
						target[i].className = "demoClass";
						target[i].style.cssText = "outline: red solid 2px";
					}
				}            
			} else {            
				if (
					(target[i].className.includes("demo") || target[i].className !== "") &&
					target[i].tagName !== "SELECT"
				) {
					target[i].className = "form-control";
					target[i].style.cssText = "border:1px solid black";
					target[i].style.cssText = "outline: none";
				} else {
					target[i].className = "";
					target[i].style.cssText = "border:1px solid black";
					target[i].style.cssText = "outline: none";
				}
			}
        }
	}
}
export default validationErrorStyle;



// WEBPACK FOOTER //
// ./src/utils/errorStyle.js